// extracted by mini-css-extract-plugin
export default {"brandListContainer":"BrandList_brandListContainer__Bs6Ud"};